import { useEffect, useRef, useState } from "react";
import { connect } from "redux-zero/react";
import {
  Card,
  IconButton,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Checkbox,
} from "@mui/material";
import {
  downloadMedia,
  extractPoster,
  getImageBlob,
  getImageDimensions,
  isValidHttpUrl,
  stringToColor,
} from "../../../utils/utility";
import { format } from "date-fns";
import { uploader } from "../../../utils/uploader";
import { URLS } from "../../../constants";
import "./SocialOperator.css";
import "./VideoEditor/editor.css";

import "../../../../node_modules/@syncfusion/ej2-base/styles/bootstrap5.css";
import "../../../../node_modules/@syncfusion/ej2-buttons/styles/bootstrap5.css";
import "../../../../node_modules/@syncfusion/ej2-popups/styles/bootstrap5.css";
import "../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/bootstrap5.css";
import "../../../../node_modules/@syncfusion/ej2-inputs/styles/bootstrap5.css";
import "../../../../node_modules/@syncfusion/ej2-navigations/styles/bootstrap5.css";
import "../../../../node_modules/@syncfusion/ej2-image-editor/styles/bootstrap5.css";

// Registering Syncfusion license key
import { registerLicense } from "@syncfusion/ej2-base";
import Loader from "../Loader_social";
import { reviewMedia } from "./networkCallsSocial";
import {
  Close,
  FileDownload,
  GpsFixed,
  PlayCircle,
  StarBorder,
  Star,
  CloseRounded,
  ThumbDown,
  ThumbUp,
  ThumbUpOutlined,
  ThumbDownOutlined,
} from "@mui/icons-material";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import { COLORS } from "../../../utils/colors";
import {
  dataURItoBlob,
  imageDataToDataURL,
} from "../../../utils/mediaFunctions";
import AiTools from "./AiTools";
import ImageEditor from "./ImageEditor";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import VideoTrimmer from "../../../components/VideoTrimmer/VideoTrimmer";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const allDestinations = [
  {
    id: 1,
    name: "Social Scroll",
    value: "social_scroll",
  },
  {
    id: 2,
    name: "Social Output",
    value: "social_output",
  },
];

registerLicense(
  "ORg4AjUWIQA/Gnt2UFhhQlJBfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5XdEZjXn1Zc3VUQmNV"
);
const EventInteractionCard = ({
  media,
  showApproveButton,
  handleReviewMedia,
  handleReviewQuote,
  emptyCard,
  initialState,
  approved,
  selectForBulkApproval,
  draggableItem = false,
  isProductionUploads = false,
}) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const [isLoading, setIsLoading] = useState(false);
  const [mediaPreviewOpen, setMediaPreviewOpen] = useState(false);
  const [username, setUsername] = useState(media && media.userId);
  const [description, setDescription] = useState(media && media.comment);
  const [showOnQuotesChecked, setShowOnQuotesChecked] = useState(
    media && media.showOnQuotesFeed
  );
  const [replaceOriginal, setReplaceOriginal] = useState(false);
  const [editorTimings, setEditorTimings] = useState([]);
  const imageEditorRef = useRef(null);
  const videoMetaData = useRef({ width: 0, height: 0 });
  const imageMetaData = useRef({ width: 0, height: 0 });
  const [updatedVideo, setUpdatedVideo] = useState(null);
  const [updatedImage, setUpdatedImage] = useState(null);
  const [generatedImage, setGeneratedImage] = useState(null);

  const [selectedDestinations, setSelectedDestinations] = useState([]);
  const handleDestinationChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedDestinations(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const handleSaveCopy = async () => {
    // Made async to use fetch
    if (!media || !media._id) {
      console.error("Media ID is missing.");
      return;
    }
    if (!selectedDestinations || selectedDestinations.length === 0) {
      console.warn("No destinations selected for copying.");
      // Optionally, show a message to the user
      return;
    }

    setIsLoading(true); // Set loading state
    if (updatedVideo || updatedImage) {
      //upload the updated/trimmed video file
      const payload = {
        eventId: initialState.event_id,
        userId: username,
        comment: description,
        isEdited: updatedImage ? true : false,
        userLocation: JSON.stringify(media.userLocation),
        tags: updatedImage ? [] : selectedDestinations,
        isProductionUploads: true,
      };
      if (
        selectedDestinations.length > 0 &&
        (selectedDestinations.includes("social_scroll") ||
          selectedDestinations.includes("social_output"))
      ) {
        payload["isReviewed"] = true;
      }

      if (media.videoPosterUrl) {
        payload.videoPosterUrl = media.videoPosterUrl;
      }
      payload.mediaFile = updatedVideo ? updatedVideo.blob : updatedImage.blob;
      const uploadResponse = await uploader({
        url: URLS.UPLOAD_MEDIA(),
        body: payload,
      });

      if (generatedImage?.url && activeTab === 1) {
        await submitGeneratedImage(
          uploadResponse.json.sharedMedia._id,
          true,
          selectedDestinations
        );
      }
      setIsLoading(false);
    } else {
      try {
        // Use the correctly defined URLS.COPY_TO_TAGS
        const response = await fetch(URLS.COPY_TO_TAGS(), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token: initialState?.loggedInUserObj?.token, // Include the token from local storage
            // Add any other required headers, e.g., authorization tokens if needed
          },
          body: JSON.stringify({
            id: media._id,
            tags: selectedDestinations,
          }),
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(
            errorData.message || `HTTP error! status: ${response.status}`
          );
        }

        const result = await response.json();
        console.log("Copy successful:", result);
        // Close the preview dialog on success
        setMediaPreviewOpen(false);
        // Optionally, show a success message or refresh data
      } catch (error) {
        console.error("Error copying media:", error);
        // Show an error message to the user
      } finally {
        setIsLoading(false); // Reset loading state
      }
    }
  };

  const submitGeneratedImage = async (
    sourceMediaId,
    isReviewed = false,
    tags = []
  ) => {
    setIsLoading(true);
    const generatedImageBlob = await getImageBlob(generatedImage.url);
    const { width, height } =
      generatedImage.width && generatedImage.height
        ? { width: generatedImage.width, height: generatedImage.height }
        : await getImageDimensions(generatedImage.url);
    setIsLoading(false);
    const payload = {
      generatedFromMediaId: sourceMediaId,
      width: width,
      height: height,
      orientation: "square",
      isReviewed: isReviewed,
      tags: tags,
      generatedImage: generatedImageBlob,
    };
    setIsLoading(true);
    await uploader({
      url: URLS.UPLOAD_GENERATED_MEDIA(),
      body: payload,
    });
    setIsLoading(false);
  };
  const saveGeneratedVideo = async (video) => {
    setIsLoading(true);
    const generatedVideoBlob = await getImageBlob(video.url);

    //upload the updated/trimmed video file
    const payload = {
      generatedFromMediaId: media._id,
      eventId: initialState.event_id,
      userId: username,
      comment: description,
      userLocation: JSON.stringify(media.userLocation),
      tags: selectedDestinations,
    };
    if (
      selectedDestinations.includes("social_scroll") ||
      selectedDestinations.includes("social_output")
    ) {
      payload["isReviewed"] = true;
    }
    if (media.videoPosterUrl) {
      payload.videoPosterUrl = media.videoPosterUrl;
    }
    payload["isProductionUploads"] = "true";
    payload["isAiGenerated"] = "true";
    payload.mimeType = video.content_type;
    payload.mediaFile = generatedVideoBlob;

    const uploadResponse = await uploader({
      url: URLS.UPLOAD_MEDIA(),
      body: payload,
    });

    setIsLoading(false);
  };
  const approveButtonClicked = async () => {
    setIsLoading(true);
    try {
      let approvalId = media._id;
      if (updatedVideo || updatedImage) {
        //reject to remove old media item
        if (replaceOriginal) {
          await handleReviewMedia(
            initialState.loggedInUserObj,
            approvalId,
            false,
            username,
            description,
            showOnQuotesChecked
          );
        }

        //upload the updated/trimmed video file
        const payload = {
          eventId: initialState.event_id,
          userId: username,
          comment: description,
          isEdited: updatedImage ? true : false,
          userLocation: JSON.stringify(media.userLocation),
        };
        if (isProductionUploads) {
          payload["isProductionUploads"] = true;
        }
        if (media.videoPosterUrl) {
          payload.videoPosterUrl = media.videoPosterUrl;
        }
        payload.mediaFile = updatedVideo
          ? updatedVideo.blob
          : updatedImage.blob;
        const uploadResponse = await uploader({
          url: URLS.UPLOAD_MEDIA(),
          body: payload,
        });
        //update the uploaded id to approve
        approvalId = uploadResponse.json.sharedMedia._id;

        await reviewMedia(
          initialState.loggedInUserObj,
          approvalId,
          isProductionUploads ? false : true,
          username,
          description,
          showOnQuotesChecked,
          getMetaData(media?.mimeType.includes("video"))
        );
        if (generatedImage?.url && activeTab === 1) {
          await submitGeneratedImage(approvalId, true);
        }
      } else {
        if (media?.isQuoteOnly) {
          handleReviewQuote({
            loggedInUserObj: initialState.loggedInUserObj,
            ...media,
            comment: description,
            userId: username,
            isReviewed: true,
          });
        } else {
          // approve the media item with updated id
          const metadata = getMetaData(media?.mimeType.includes("video"));
          await handleReviewMedia(
            initialState.loggedInUserObj,
            approvalId,
            true,
            username,
            description,
            showOnQuotesChecked,
            metadata
          );
          if (generatedImage?.url && activeTab === 1) {
            await submitGeneratedImage(media._id, true);
          }
        }
      }

      setMediaPreviewOpen(false);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const updateTrimmedVideo = async () => {
    setIsLoading(true);
    try {
      //upload the updated/trimmed video file
      const payload = {
        eventId: initialState.event_id,
        userId: username,
        comment: description,
        userLocation: JSON.stringify(media.userLocation),
      };
      if (isProductionUploads) {
        payload["isProductionUploads"] = true;
      }

      if (media.videoPosterUrl) {
        payload.videoPosterUrl = media.videoPosterUrl;
      }
      payload.mediaFile = updatedVideo ? updatedVideo.blob : updatedImage.blob;
      const uploadResponse = await uploader({
        url: URLS.UPLOAD_MEDIA(),
        body: payload,
      });
    } catch (error) {
    } finally {
      setIsLoading(false);
      setMediaPreviewOpen(false);
      setUpdatedVideo(null);
    }
  };

  useEffect(() => {
    getLocationAddress();
  }, []);

  const [address, setAddress] = useState("0, 0");
  const getLocationAddress = () => {
    try {
      if (media && media.userLocation && media.userLocation.name) {
        setAddress(media.userLocation.name);
      } else {
        setAddress("0, 0");
      }
    } catch (error) {
      setAddress("0, 0");
    }
  };
  const getMetaData = (isVideo) => {
    if (isVideo) {
      return videoMetaData.current;
    } else if (imageMetaData.current.width && imageMetaData.current.height) {
      return imageMetaData.current;
    } else {
      if (imageEditorRef.current) {
        const imageData = imageEditorRef.current.getImageData();
        if (imageData && imageData.width && imageData.height) {
          imageMetaData.current = {
            width: imageData.width,
            height: imageData.height,
          };
        }
      }
      return imageMetaData.current;
    }
  };

  const renderEmptyCard = () => {
    return (
      <Card
        className="soCard soEventInteractionCard"
        style={{ borderWidth: "0px !important" }}
      >
        <div></div>
      </Card>
    );
  };

  const updatedVideoBlob = async (newFile) => {
    setUpdatedVideo(newFile);
    if (newFile?.blob) {
      const videoPosterUrl = await extractPoster(undefined, newFile.blob);
      media.videoPosterUrl = videoPosterUrl;
    }
  };

  const updateVideoDimensions = (videoWidth, videoHeight) => {
    videoMetaData.current.width = videoWidth;
    videoMetaData.current.height = videoHeight;
  };

  const onVideoDataLoaded = async (fileBlob, fileUrl) => {
    if (
      fileBlob &&
      media.videoPosterUrl !== "" &&
      typeof media.videoPosterUrl !== "string"
    ) {
      const videoPosterUrl = await extractPoster(undefined, fileBlob);
      media.videoPosterUrl = videoPosterUrl;
    } else if (
      fileUrl &&
      media.videoPosterUrl !== "" &&
      typeof media.videoPosterUrl !== "string"
    ) {
      const videoPosterUrl = await extractPoster(fileUrl, undefined);
      media.videoPosterUrl = videoPosterUrl;
    }
  };

  const beforeUnload = async () => {
    if (!updatedVideo) {
      if (media?.videoPosterUrl && isValidHttpUrl(media.videoPosterUrl)) {
        // Do nothing
      } else {
        if (media?.videoPosterUrl?.size) {
          const uploadResponse = await uploader({
            url: URLS.UPLOAD_VIDEO_POSTER(),
            body: {
              sharedMediaId: media._id,
              videoPosterUrl: media.videoPosterUrl,
            },
          });
          if (uploadResponse && uploadResponse?.json?.videoPosterUrl) {
            const newPosterUrl = uploadResponse?.json?.videoPosterUrl;
            media.videoPosterUrl = newPosterUrl;
            const el = document.getElementById(media._id);
            const blurEl = document.getElementById("blur" + media._id);
            if (el) {
              el.poster = newPosterUrl;
              el.src = "";
            }
            if (blurEl) {
              blurEl.poster = newPosterUrl;
              blurEl.src = "";
            }
          }
        }
      }
    }
  };

  const onSaveImage = () => {
    if (imageEditorRef.current) {
      const imageData = imageEditorRef.current.getImageData();
      if (imageData && imageData.width && imageData.height) {
        imageMetaData.current = {
          width: imageData.width,
          height: imageData.height,
        };
      }
      const imageDataUrl = imageDataToDataURL(imageData);
      const blob = dataURItoBlob(imageDataUrl);
      setUpdatedImage({ blob: blob, dataUrl: imageDataUrl });
    }
  };

  const renderTextInfo = () => {
    return (
      <div className="mediaPreviewInputFields">
        <div className="nameAndDescription">
          <TextField
            size="small"
            defaultValue={username}
            margin="dense"
            id="username"
            label="Username"
            InputLabelProps={{ style: { color: "white" } }}
            InputProps={{ style: { color: "white" } }}
            fullWidth
            onChange={(e) => {
              setUsername(e.target.value);
            }}
            inputProps={{ maxLength: 20 }}
          />
          <TextField
            size="small"
            onInput={(e) => {}}
            defaultValue={description}
            margin="dense"
            id="description"
            label="Media Description"
            InputLabelProps={{ style: { color: "white" } }}
            InputProps={{ style: { color: "white" } }}
            fullWidth
            onChange={(e) => {
              setDescription(e.target.value);
            }}
            multiline={true}
            sx={{ marginLeft: 1 }}
          />
        </div>

        <div className="addressDiv">
          {address.length > 4 && (
            <div
              className="gpsAddress"
              onClick={() => {
                window.open(
                  `https://www.google.com/maps/search/?api=1&query=${media.userLocation.coordinates[1]},${media.userLocation.coordinates[0]}`
                );
              }}
            >
              <GpsFixed style={{ color: COLORS.textLabel }} />
              <Typography
                style={{
                  color: COLORS.textLabel,
                  textAlign: "start",
                  fontSize: 12,
                  marginLeft: 5,
                }}
              >
                {address}
              </Typography>
            </div>
          )}
          <Typography
            style={{
              color: COLORS.textLabel,
              fontSize: 12,
              marginLeft: "16px",
              padding: "10px 0px",
            }}
          >
            {"Uploaded on: " +
              format(new Date(media?.createdAt * 1000), "dd MMM yyyy hh:mm a")}
          </Typography>
        </div>
      </div>
    );
  };

  const onGenerated = (generatedMedia) => {
    setGeneratedImage(generatedMedia);
  };

  const renderImageReviewer = () => {
    return (
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            variant="fullWidth"
            value={activeTab}
            onChange={handleTabChange}
            aria-label="Review media tabs"
            className="review-media-tabs"
          >
            <Tab label="Review Image" className="review-media-tab" />
            <Tab label="AI Transform" className="review-media-tab" />
          </Tabs>
        </Box>
        <CustomTabPanel value={activeTab} index={0}>
          <ImageEditor
            onSaveImage={onSaveImage}
            ref={imageEditorRef}
            media={media}
            showApproveButton={showApproveButton}
          />
        </CustomTabPanel>
        <CustomTabPanel value={activeTab} index={1}>
          <AiTools
            media={media}
            editedImage={updatedImage?.dataUrl}
            onGenerated={onGenerated}
            eventDetails={initialState}
            onVideoGenerated={saveGeneratedVideo}
          />
        </CustomTabPanel>
      </Box>
    );
  };

  const renderVideoEditor = () => {
    return (
      <VideoTrimmer
        videoUrl={media?.mediaFileUrl}
        showControls={showApproveButton || isProductionUploads}
        timings={editorTimings}
        setTimings={setEditorTimings}
        hasVideoPoster={media?.videoPosterUrl ? true : false}
        updatedVideoBlob={updatedVideoBlob}
        updateVideoDimensions={updateVideoDimensions}
        onVideoDataLoaded={onVideoDataLoaded}
        beforeUnload={beforeUnload}
      />
    );
  };
  const renderIcons = (draggableItem) => {
    return draggableItem ? (
      <>
        <IconButton
          className="soApproveButton"
          onClick={() =>
            media?.isQuoteOnly
              ? handleReviewQuote({
                  loggedInUserObj: initialState.loggedInUserObj,
                  ...media,
                  comment: description,
                  userId: username,
                  isReviewed: false,
                })
              : handleReviewMedia(
                  initialState.loggedInUserObj,
                  media._id,
                  false,
                  username,
                  description,
                  showOnQuotesChecked
                )
          }
          size="medium"
        >
          <Close />
        </IconButton>
        {isProductionUploads && (
          <IconButton
            className="soDownloadButton"
            onClick={() => downloadMedia(media?.mediaFileUrl, media._id)}
            size="medium"
          >
            <FileDownload />
          </IconButton>
        )}
      </>
    ) : (
      <>
        <IconButton
          className="soApproveButton"
          onClick={() =>
            media?.isQuoteOnly
              ? handleReviewQuote({
                  loggedInUserObj: initialState.loggedInUserObj,
                  ...media,
                  comment: description,
                  userId: username,
                  isReviewed: false,
                })
              : handleReviewMedia(
                  initialState.loggedInUserObj,
                  media._id,
                  false,
                  username,
                  description,
                  showOnQuotesChecked
                )
          }
          size="medium"
        >
          <Close />
        </IconButton>

        {approved ? (
          <IconButton
            className="star"
            title="Starred media will not be purged."
            onClick={(e) => {
              e.stopPropagation();
              media?.isQuoteOnly
                ? handleReviewQuote({
                    loggedInUserObj: initialState.loggedInUserObj,
                    ...media,
                    comment: description,
                    userId: username,
                    isStarred: media?.isStarred ? false : true,
                  })
                : handleReviewMedia(
                    initialState.loggedInUserObj,
                    media._id,
                    approved,
                    username,
                    description,
                    showOnQuotesChecked,
                    undefined,
                    media?.isStarred ? false : true
                  );
            }}
            size="medium"
          >
            {media.isStarred ? (
              <Star sx={{ color: "#FFD700" }} />
            ) : (
              <StarBorder />
            )}
          </IconButton>
        ) : (
          <>
            <IconButton
              className="rightTick thumb-up"
              title="Select for Bulk Approval"
              onClick={(e) => {
                e.stopPropagation();
                selectForBulkApproval(media._id, true);
              }}
              size="medium"
            >
              {media?.selectedClass === "selected-approval" ? (
                <ThumbUp />
              ) : (
                <ThumbUpOutlined />
              )}
            </IconButton>
            <IconButton
              className="selectForBulkRemove thumb-down"
              title="Select for Bulk Deletion"
              onClick={(e) => {
                e.stopPropagation();
                selectForBulkApproval(media._id, false);
              }}
              size="medium"
            >
              {media?.selectedClass === "selected-rejection" ? (
                <ThumbDown />
              ) : (
                <ThumbDownOutlined />
              )}
            </IconButton>
          </>
        )}
        {!media?.isQuoteOnly && (
          <IconButton
            className="soDownloadButton"
            onClick={() => downloadMedia(media?.mediaFileUrl, media._id)}
            size="medium"
          >
            <FileDownload />
          </IconButton>
        )}
      </>
    );
  };

  return emptyCard ? (
    renderEmptyCard()
  ) : (
    <Card
      className={`soCard soEventInteractionCard${
        media?.isStarred ? " starredCard" : ""
      }${media?.isQuoteOnly ? " quoteOnlyCardOuter" : ""} ${
        media?.selectedClass
      }`}
      style={
        media.generatedFromMediaId
          ? { border: `2px ridge ${stringToColor(media.generatedFromMediaId)}` }
          : media.hasGeneratedMediaId
          ? { border: `2px ridge ${stringToColor(media._id)}` }
          : {}
      }
    >
      <Dialog
        open={mediaPreviewOpen}
        onClose={() => setMediaPreviewOpen(false)}
        classes={{
          paper: media.isQuoteOnly
            ? "soDialogPaperQuotesOnly"
            : "soDialogPaper",
        }}
      >
        <IconButton
          className="soDialogClose"
          onClick={() => setMediaPreviewOpen(false)}
        >
          <CloseRounded />
        </IconButton>
        <DialogContent
          sx={{ display: "flex", flexDirection: "column", paddingBottom: 0 }}
        >
          {media?.isQuoteOnly ? null : (
            <div className="soMediaPreview">
              {media?.mimeType?.includes("video")
                ? renderVideoEditor()
                : renderImageReviewer()}
            </div>
          )}
          {activeTab !== 1 && renderTextInfo()}

          {isLoading && (
            <div className="soLoaderStyle">
              <Loader />
            </div>
          )}
        </DialogContent>

        {!draggableItem && (
          <DialogActions className="soDialogActions">
            <Button
              variant="outlined"
              onClick={() => {
                media?.isQuoteOnly
                  ? handleReviewQuote({
                      loggedInUserObj: initialState.loggedInUserObj,
                      ...media,
                      comment: description,
                      userId: username,
                    })
                  : handleReviewMedia(
                      initialState.loggedInUserObj,
                      media._id,
                      false,
                      username,
                      description,
                      showOnQuotesChecked
                    );
                setMediaPreviewOpen(false);
              }}
            >
              {showApproveButton ? "Reject" : "Remove"}
            </Button>
            {media?.isQuoteOnly ? null : (
              <div
                className="soShowOnQuotesCheckbox"
                onClick={() => {
                  setShowOnQuotesChecked(!showOnQuotesChecked);
                }}
              >
                <Checkbox
                  checked={showOnQuotesChecked}
                  sx={{
                    color: "white",
                    "&.Mui-checked": {
                      color: "white",
                    },
                  }}
                />
                <Typography color={"white"}>Approve Quote</Typography>
              </div>
            )}

            <Button
              style={{
                color: "white",
              }}
              variant="contained"
              onClick={async () => {
                await approveButtonClicked();
              }}
            >
              {showApproveButton
                ? generatedImage?.url && activeTab === 1
                  ? "Approve with Generated Image"
                  : "Approve"
                : generatedImage?.url && activeTab === 1
                ? "Approve with Generated Image"
                : "Update"}
            </Button>
          </DialogActions>
        )}
        {isProductionUploads ? (
          media?.mimeType?.includes("video") ? (
            <DialogActions className="soDialogActions">
              <FormControl sx={{ m: 1, width: 300 }}>
                <InputLabel
                  id="demo-multiple-checkbox-label-1 text-white"
                  sx={{ color: "white", borderColor: "white" }}
                >
                  Select Save Destinations
                </InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label-1"
                  id="demo-multiple-checkbox"
                  sx={{ color: "white", borderColor: "white" }}
                  multiple
                  value={selectedDestinations}
                  onChange={handleDestinationChange}
                  input={
                    <OutlinedInput
                      label="Select Save Destinations"
                      sx={{
                        color: "white",
                        borderColor: "white",
                      }}
                    />
                  }
                  renderValue={(selected) => selected.join(", ")}
                  MenuProps={MenuProps}
                  className="text-white"
                >
                  {allDestinations.map((destination) => (
                    <MenuItem
                      key={destination.id}
                      value={destination.value}
                      className="text-white"
                    >
                      <Checkbox
                        checked={selectedDestinations.includes(
                          destination.value
                        )}
                      />
                      <ListItemText primary={destination.name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {updatedVideo ? (
                <Button
                  style={{
                    color: "white",
                  }}
                  variant="contained"
                  onClick={async () => {
                    await updateTrimmedVideo();
                    handleSaveCopy();
                  }}
                >
                  Update Video
                </Button>
              ) : (
                <Button
                  variant="contained"
                  disabled={selectedDestinations.length === 0 ? true : false}
                  style={{
                    color: "white",
                  }}
                  onClick={handleSaveCopy}
                >
                  Save a Copy
                </Button>
              )}
            </DialogActions>
          ) : (
            <DialogActions className="soDialogActions">
              <Button
                variant="outlined"
                onClick={() => {
                  media?.isQuoteOnly
                    ? handleReviewQuote({
                        loggedInUserObj: initialState.loggedInUserObj,
                        ...media,
                        comment: description,
                        userId: username,
                      })
                    : handleReviewMedia(
                        initialState.loggedInUserObj,
                        media._id,
                        false,
                        username,
                        description,
                        showOnQuotesChecked
                      );
                  setMediaPreviewOpen(false);
                }}
              >
                {showApproveButton ? "Reject" : "Remove"}
              </Button>
              {media?.isQuoteOnly ? null : (
                <div
                  className="soShowOnQuotesCheckbox"
                  onClick={() => {
                    setShowOnQuotesChecked(!showOnQuotesChecked);
                  }}
                >
                  <Checkbox
                    checked={showOnQuotesChecked}
                    sx={{
                      color: "white",
                      "&.Mui-checked": {
                        color: "white",
                      },
                    }}
                  />
                  <Typography color={"white"}>Approve Quote</Typography>
                </div>
              )}

              <FormControl sx={{ m: 1, width: 300 }}>
                <InputLabel
                  id="demo-multiple-checkbox-label"
                  sx={{ color: "white" }}
                >
                  Select Save Destinations
                </InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  multiple
                  value={selectedDestinations}
                  onChange={handleDestinationChange}
                  input={
                    <OutlinedInput
                      label="Select Save Destinations"
                      sx={{
                        color: "white",
                      }}
                    />
                  }
                  renderValue={(selected) => selected.join(", ")}
                  MenuProps={MenuProps}
                >
                  {allDestinations.map((destination) => (
                    <MenuItem
                      key={destination.id}
                      value={destination.value}
                      className="text-white"
                    >
                      <Checkbox
                        checked={selectedDestinations.includes(
                          destination.value
                        )}
                      />
                      <ListItemText primary={destination.name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Button
                variant="contained"
                disabled={selectedDestinations.length === 0}
                style={{
                  color: "white",
                }}
                onClick={handleSaveCopy}
              >
                Save a Copy
              </Button>
              {/* </>
            )} */}
            </DialogActions>
          )
        ) : null}
      </Dialog>
      <div
        style={{ height: "100%" }}
        className={draggableItem ? "droppable-element" : ""}
        draggable={draggableItem}
        unselectable="on"
        onDragStart={(e) =>
          e.dataTransfer.setData(
            "text/plain",
            JSON.stringify({
              comment: media?.comment,
              mediaFileUrl: media?.mediaFileUrl,
              mimeType: media?.mimeType,
              id: media?._id,
              userId: media?.userId,
              userLocation: media?.userLocation,
              videoPosterUrl: media?.videoPosterUrl,
            })
          )
        }
      >
        {media?.mimeType?.includes("video") ||
        media?.mimeType?.includes("text") ? (
          <div
            className="soImageMedia skeleton"
            onClick={(e) => {
              setMediaPreviewOpen(true);
            }}
          >
            <video
              className="soVideoMedia"
              id={"blur" + media._id}
              src={media.videoPosterUrl ? "" : media?.mediaFileUrl}
              playsInline
              loop
              controls={false}
              muted
              style={{
                objectFit: "fill",
                filter: "blur(10px)",
              }}
              disableRemotePlayback={true}
              poster={media.videoPosterUrl}
            />
            <video
              className="soVideoMedia"
              id={media._id}
              src={media.videoPosterUrl ? "" : media?.mediaFileUrl}
              playsInline
              loop
              controls={false}
              muted
              style={{
                zIndex: 11,
              }}
              disableRemotePlayback={true}
              poster={media.videoPosterUrl}
              onLoad={(e) => {
                onVideoDataLoaded(undefined, media?.mediaFileUrl);
              }}
            />
            <PlayCircle
              style={{
                position: "absolute",
                alignSelf: "center",
                color: "lightgray",
                zIndex: 12,
                top: "calc(50% - 25px)",
                left: "calc(50% - 25px)",
                width: "50px",
                height: "50px",
              }}
            />
          </div>
        ) : media?.mimeType?.includes("image") ? (
          <div
            className="soImageMedia skeleton"
            onClick={(e) => {
              setMediaPreviewOpen(true);
            }}
          >
            <img
              alt="media"
              className="soImageMedia"
              src={media?.mediaFileUrl}
              style={{
                objectFit: "fill",
                filter: "blur(10px)",
              }}
            />
            <img
              alt="media"
              className="soImageMedia"
              src={media?.mediaFileUrl}
              style={{
                position: "absolute",
                left: 0,
                objectFit: "contain",
              }}
            />
          </div>
        ) : media.isQuoteOnly ? (
          <div
            className="soImageMedia quoteOnlyCard"
            onClick={(e) => {
              setMediaPreviewOpen(true);
            }}
          >
            {media.comment}
          </div>
        ) : (
          <div
            className="soImageMedia skeleton"
            onClick={(e) => {
              setMediaPreviewOpen(true);
            }}
          >
            <img
              alt="media"
              className="soImageMedia"
              src={media?.mediaFileUrl}
              style={{
                objectFit: "fill",
                filter: "blur(10px)",
              }}
            />
            <img
              alt="media"
              className="soImageMedia"
              src={media?.mediaFileUrl}
              style={{
                position: "absolute",
                left: 0,
                objectFit: "contain",
              }}
            />
          </div>
        )}
      </div>
      {renderIcons(draggableItem)}
      {media?.userId && <div className="eic-username">{media?.userId}</div>}
    </Card>
  );
};

export default connect((state) => ({ initialState: state.initialState }))(
  EventInteractionCard
);
function CustomTabPanel(props) {
  const { children, value, index } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{
        height: "calc(100% - 49px)",
        position: "relative",
        overflowY: "auto",
      }}
    >
      {value === index && children}
    </div>
  );
}
